
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"105","height":"127.6"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#FFF","d":"M99.9 123.9h.8l-25.3-35-.1-.1 1.6-1.1C89.7 79 97 66.7 97 50.9 97 23.3 75.4 3.3 45.6 3.3L2 3.5v120.2h20.9V96.2h32.5l.3.5 3 4.1 16.6 23.1H99.9zM48.6 77.2H22.8V23.1h25.8c14.9 0 27 12.1 27 27s-12.1 27.1-27 27.1z"}})])
          )
        }
      }
    